import type { ContentPage } from "@/lib/content/types";

// CRM › Sales Enablement › Configure, Price, Quote (CPQ) (leaf).
export const configurePriceQuote: ContentPage = {
  slug: "sales-enablement/configure-price-quote",
  template: "hrmsFeature",
  seo: {
    title: "CPQ Software - Configure, Price, Quote | GetBiz CRM",
    description: "Create fast, accurate quotes with GetBiz CRM CPQ. Configure products, apply pricing rules and discounts, and send branded quotes in seconds.",
    keywords: ["cpq software", "configure price quote", "quoting software", "sales quotes crm"],
    ogImage: "/assets/data/seoimages/configure-price-quote.webp",
  },
  leaf: {
    hero: {
      caption: "Configure, Price, Quote (CPQ)",
      title: "Build Accurate Quotes in Seconds",
      description: "Configure products, apply the right pricing and generate professional quotes instantly — no errors, no spreadsheets.",
      h1: "caption",
    },
    split: {
      title: "Why Teams Choose Configure, Price, Quote (CPQ)",
      bullets: [
        { title: "Guided Configuration", description: "Reps pick valid product options every time." },
        { title: "Pricing Rules", description: "Apply discounts and approvals automatically." },
        { title: "Instant Quotes", description: "Generate branded quotes in a click." },
        { title: "No Errors", description: "Rules prevent mispriced or invalid quotes." },
      ],
      image: "/assets/images/img/product/crm/configure-price-quote-lead-image.webp",
      imageAlt: "Configure, Price, Quote (CPQ) — GetBiz CRM",
    },
    cardsHeading: {
      title: "Works With the Rest of Sales Enablement",
      description: "Configure, Price, Quote (CPQ) connects to every other part of Sales Enablement in GetBiz CRM.",
    },
    cards: [
      { title: "Finance", href: "/crm-software/sales-enablement/finance/", description: "Manage quotes, invoices and payments alongside deals so revenue moves from closed-won to collected without gaps.", image: "/assets/images/img/product/crm/finance.webp", imageAlt: "GetBiz CRM finance" },
      { title: "Documents Library", href: "/crm-software/sales-enablement/documents-library/", description: "Store, share and track proposals, decks and contracts from a central library, right where your deals live.", image: "/assets/images/img/product/crm/documents-library.webp", imageAlt: "GetBiz CRM documents library" },
      { title: "Calendar", href: "/crm-software/sales-enablement/calendar/", description: "Sync calendars, share booking links and see all your meetings next to the deals and contacts they belong to.", image: "/assets/images/img/product/crm/calendar.webp", imageAlt: "GetBiz CRM calendar" },
      { title: "SalesInbox", href: "/crm-software/sales-enablement/salesinbox/", description: "Work email inside the CRM with full deal context beside every message.", image: "/assets/images/img/product/crm/salesInbox.webp", imageAlt: "GetBiz CRM salesinbox" },
    ],
    testimonials: {
      title: "Businesses across India love & trust GetBiz!",
      description: "See why teams choose GetBiz CRM to run their sales.",
    },
    bookDemoTitle: "See Configure, Price, Quote (CPQ) in action.",
    relatedBlogs: "static",
    metaKey: "sales-enablement-configure-price-quote",
  },
  sections: [],
};
